<template>
  <div class="public-list" v-if="info">
    <Info :data="info"/>
  </div>
</template>
<script>
import Info from './Info'
export default {
  components: {Info},
  data() {
    return {
      info: null
    }
  },
  mounted() {
    const { id } = this.$route.params
    this.$store.dispatch('get_window_zt', {id})
    .then(res => {
      this.info = res
    })
  }
}
</script>

<style lang="less" scoped>

</style>
